<script setup lang="ts">
defineProps<{
  active: boolean
  primaryText?: string
  secondaryText?: string
}>()
</script>

<template>
  <div
    :class="`relative flex items-center space-x-6 rounded border ${
      active ? 'border-tt-pale' : 'border-tt-pale/25'
    } p-4`"
  >
    <span
      class="flex-1 overflow-hidden text-ellipsis whitespace-nowrap text-base"
    >
      <slot name="primary">
        {{ primaryText }}
      </slot>
    </span>
    <slot name="secondary">
      <span class="flex-shrink-0 text-tt-light-gray">{{ secondaryText }}</span>
    </slot>
    <span
      v-if="active"
      class="absolute -right-3 top-1/2 h-1 w-1 -translate-y-1/2 rounded-full bg-tt-green"
    >
    </span>
  </div>
</template>
